module.exports = __webpack_public_path__ + "img/banner_mega10.aba962e2.jpg";